// Home - Guía de estilos (sections/home-style-guide.liquid)
// Desktop accordion: hovering, focusing or tapping a panel expands it. Below 1100px it is a plain scroller.

const HSG_DESKTOP = "(min-width: 1100px)"

class HomeStyleGuide extends HTMLElement {
	connectedCallback() {
		this.items = [...this.querySelectorAll("[data-hsg-item]")]
		this.desktop = window.matchMedia(HSG_DESKTOP)
		this.canHover = window.matchMedia("(hover: hover)").matches

		this.items.forEach(item => {
			if (this.canHover) item.addEventListener("mouseenter", () => this.activate(item))
			// Keyboard focus only: a tap also focuses the link and would skip the first-tap-opens step
			item.addEventListener("focus", () => {
				if (item.matches(":focus-visible")) this.activate(item)
			})

			// Touch on a wide screen: the first tap opens the panel, the second one follows the link
			item.addEventListener("click", event => {
				if (!this.desktop.matches || item.classList.contains("is-active")) return
				event.preventDefault()
				this.activate(item)
			})
		})

		if (window.Shopify?.designMode) document.addEventListener("shopify:block:select", this.onBlockSelect)
	}

	disconnectedCallback() {
		document.removeEventListener("shopify:block:select", this.onBlockSelect)
	}

	activate(item) {
		if (!this.desktop.matches) return
		this.items.forEach(other => other.classList.toggle("is-active", other === item))
	}

	onBlockSelect = event => {
		let item = this.items.find(i => i === event.target)
		if (item) this.activate(item)
	}
}

if (!customElements.get("home-style-guide")) customElements.define("home-style-guide", HomeStyleGuide)
